<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="GetProofingList()" style="display:none">Get</button>
        <button type="button" (click)="show()" id="btn_AddNew" style="display:none">
          Add
        </button>
        <div id="proofingTable" class="divContainer" style="top:1px;">
          <div class="row" id="Filters">
            <div class="col-sm-1">
              <label>Proofing Type</label>
              <select id="ddlProofingTypeFilter" class="form-control" autocomplete="off">
                <option value="All" selected="selected">Select</option>
                <option *ngFor="let item of ProofingType" value={{item.ProofingType}}>
                  {{item.ProofingType}}
                </option>
              </select>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label>Journal</label>
                <select class="form-control" id="ddljournals" multiple>
                  <option *ngFor="let item of journalList" value={{item.ID}}>{{item.Acronym}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Stage List</label>
                <select class="form-control" id="ddlstagelistid" multiple>
                  <option *ngFor="let item of artstageList" value={{item.StageName}}>{{item.StageName}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="GetProofingList()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>

          <table #dataTable class="display" style="width:100%"></table>
          <button type="button" id="btnDeleteConfig" (click)="DeleteConfig()" style="display:none">Delete Config</button>
          <button type="button" id="btnDeleteDT" (click)="Delete()" style="display:none">Delete</button>
          <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
          <button type="button" id="btnClone" (click)="ConfirmationCloneProofingConfig()" style="display:none">Clone Confirm</button>
          <button type="button" id="btnCloneConfig" (click)="CloneProofingConfig()" style="display:none">Clone Confirm</button>
        </div>

        <div class="main-body" id="proofingForm" style="overflow: hidden; overflow-y: auto">
          <div class="row">
            <!-- ProofingSystem  Main Content-->
            <div class="col-sm-4" id="divProofSystemData" style="overflow: hidden; overflow-y: auto">
              <form role="form">
                <div class="row divContentLeft">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Proofing Workflow Name</label><em>*</em>
                      <input class="form-control" id="txtName" type="text" placeholder="">
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Proofing Type</label><em>*</em>
                      <select class="form-control" id="ddlProofingType">
                        <option value="Select" selected="selected">Select</option>
                        <option value="EG">EG</option>
                        <option value="EPT">EPT</option>
                        <option value="EPDS">EPDS</option>
                        <option value="CASPER">CASPER</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <input type="checkbox" id="IsIssue">&nbsp;
                      <label>IsIssue</label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Article Stage</label><em>*</em>
                      <select class="form-control" id="ddlartstageList" multiple (change)="GetApplyToList()">
                        <!--<option value="0" selected="selected">Select</option>-->
                        <option *ngFor="let item of artstageList" value={{item.ID}}>{{item.StageName}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Journal Selection</label>
                      <select class="form-control" id="ddljournalList" multiple (change)="GetApplyToList()">
                        <!--<option value="0" selected="selected">Select</option>-->
                        <option *ngFor="let item of journalList" value={{item.ID}}>{{item.Acronym}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Article Type Selection</label>
                      <select class="form-control" id="ddlarticleList" multiple (change)="GetApplyToList()">
                        <!--<option value="0" selected="selected">Select</option>-->
                        <option *ngFor="let item of articleTypeList" value={{item.SNo}}>{{item.TypeName}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <label>Languages</label>
                    <select id="ddlLanguageList" class="form-control" multiple>
                      <!--<option value="0" selected="selected">Select Language</option>-->
                      <option *ngFor="let item of Language" value={{item.ID}}>
                        {{item.Language}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-12">
                    <label>Country</label>
                    <select id="ddlCountryList" class="form-control" multiple>
                      <option *ngFor="let item of CountryList" value={{item.ID}}>
                        {{item.CountryName}}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Instructions</label>
                      <input class="form-control" id="txtInstructions" type="text" placeholder="">
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- ProofingSystem Config and Reminder Data -->
            <div class="col-sm-8" id="divConfigReminderData">
              <div style="background-color:white">
                <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul" role="tablist">
                  <li class="nav-item"> <a data-toggle="tab" href="#ConfigTab" (click)="tabclick()" name="Config" class="nav-link active">Config</a></li>
                  <li class="nav-item"><a data-toggle="tab" href="#ReminderTab" (click)="tabclick()" name="Reminder" class="nav-link">Reminder</a></li>

                  <li class="nav-item tab_btn">
                    <button class="btn btn-outline-info waves-effect waves-light proofingAddbtn" (click)="ShowTransPopup()">
                      <i class="fa fa-plus"></i>
                    </button>
                  </li>
                </ul>
                <!--tab-->

                <div class="tab-content">
                  <div id="ConfigTab" class="tab-pane active">
                    <span id="spAddConfig" class="proofingAddbtn" (click)="ShowConfig()" style="display:none"></span>
                    <span id="spUpdateConfig" class="proofingAddbtn" (click)="UpdateConfigData()" style="display:none"></span>


                    <div class="col-md-12">
                      <div class="form-group tblRightsList fixTableHead">
                        <table id="tblAddConfigList" class="table" style="width: 100%">

                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Stage</th>
                              <th>Sequence</th>
                              <th>TAT</th>
                              <th>Mail Subject</th>
                              <th style="display:none">From Name </th>
                              <th style="display:none">From Email </th>
                              <th style="display:none">FromCopyrights </th>
                              <th style="display:none">To Name </th>
                              <th style="display:none">To Email </th>
                              <th style="display:none">ToCopyrights </th>
                              <th style="display:none">CC </th>
                              <th style="display:none">Submit CC</th>
                              <th style="display:none">BCC Email</th>
                              <th style="display:none">Signature</th>
                              <th style="display:none">OneMoreReview</th>
                              <th style="display:none">MailBody</th>
                              <th style="display:none">Instruction</th>
                              <th style="display:none">ConfirmationMailBody</th>
                              <th style="display:none">ConfirmationMailSubject</th>
                              <th style="display:none">CorrectionInputFile</th>
                              <th style="display:none">CorrectionInputInstructions</th>
                              <th style="text-align:center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!--popup config data-->
                    <div class="modal" id="myModalConfig" [style.display]="showModal ? 'block' : 'none'">
                      <div class="modal-dialog modal-xl custome-modal">
                        <div class="modal-content" id="divConfigPopup">
                          <!-- Modal Header -->

                          <div class="modal-header">
                            <h4 class="modal-title">{{title}}</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="hide()" id="btnConfigHide">&times;</button>
                          </div>

                          <div class="modal-body" style="overflow:hidden;top:-15px">

                            <!--Proofing Config Data-->
                            <div class="divMainConfig">
                              <ul class="nav nav-tabs nav-tabs-custom" id="ULTabulPopup" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" data-toggle="tab" href="#divProofing" name="Proofing">Config</a>
                                </li>
                                <li class="nav-item"><a class="nav-link " data-toggle="tab" href="#divMailDetails">MailBody</a></li>
                                <li class="nav-item" id="hideConfirmationconfig"><a class="nav-link " data-toggle="tab" href="#divConfirmationMailDetails">Confirmation MailBody</a></li>
                                <li class="nav-item" id="tabPreview" style="display:none">
                                  <a class="nav-link " data-toggle="tab" href="#divPreviewDetails">Preview</a>
                                </li>
                                <li class="nav-item tab_btn">
                                  <h6 (click)="addDynamicTagList()">
                                    <i class="fa fa-tags"></i> Dynamic Tags
                                  </h6>
                                </li>
                              </ul>
                              <br />
                              <div class="row">
                                <div class="col">
                                  <div class="tab-content">
                                    <div class="tab-pane active" id="divProofing" style="overflow: hidden; overflow-y: auto;">

                                      <form #form="ngForm" id="formConfig">

                                        <!--General Column Panel-->
                                        <div class="row">
                                          <div class="col-md-2">
                                            <div class="form-group">
                                              <label>Stage</label><em style="color:red">*</em>
                                              <select class="form-control" id="ddlStageList" placeholder="" (change)=" PopulateStageBasedData()">
                                                <option value="0" selected="selected">Select</option>
                                                <option *ngFor="let item of stageList" value={{item.ID}}>{{item.Stage}}</option>
                                              </select>
                                            </div>
                                          </div>
                                          <div class="col-md-1">
                                            <div class="form-group">
                                              <label>Sequence</label><em style="color:red">*</em>
                                              <input class="form-control" type="number" id="txtSequence" placeholder="" min="0">
                                            </div>
                                          </div>
                                          <div class="col-md-4">
                                            <div class="form-group">
                                              <label>From Email</label>
                                              <input class="form-control" type="email" id="txtFromEmail" (change)="emailidOnly($event)" maxlength="200" />
                                            </div>
                                          </div>
                                          <div class="col-md-5">
                                            <div class="form-group">
                                              <label>From Name</label>
                                              <input class="form-control" type="text" id="txtFromName" maxlength="100">
                                            </div>
                                          </div>
                                        </div>

                                        <!--To Mail Details Column Panel-->
                                        <div class="row">
                                          <div class="col-md-6">
                                            <div class="form-group">
                                              <label>To Email</label><em style="color:red">*</em>
                                              <input class="form-control" type="email" id="txtToEmail" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="form-group">
                                              <label>To Name</label><em style="color:red">*</em>
                                              <input class="form-control" type="text" id="txtToName">
                                            </div>
                                          </div>
                                        </div>

                                        <!--Bcc Mail Details Column Panel-->
                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>CC</label>
                                              <input class="form-control" type="text" id="txtCC" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>BCC Email</label>
                                              <input class="form-control" type="email" id="txtBCCEmail" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Mail Subject</label><em style="color:red">*</em>
                                              <input class="form-control" type="text" id="txtMailSubject">
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Signature</label><em style="color:red">*</em>
                                              <textarea id="txtSignature" class="form-control"></textarea>
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Confirmation Mail Subject</label>
                                              <input class="form-control" type="text" id="txtAckMailSubject">
                                            </div>
                                          </div>

                                        </div>

                                        <!--<h5>Optinal Params</h5>-->
                                        <!--<hr />-->
                                        <div class="row">
                                          <div class="col-md-3">
                                            <div class="form-group">
                                              <label>TAT</label><em style="color:red">*</em>
                                              <input class="form-control" type="number" id="txtTATConfig" placeholder="" min="0">
                                            </div>
                                          </div>
                                          <div class="col-sm-3">
                                            <div class="form-group">
                                              <br />
                                              <input type="checkbox" id="IsoneMoreReview">&nbsp;
                                              <label>IsOneMoreView </label>
                                            </div>
                                          </div>
                                          <div class="col-sm-3">
                                            <div class="form-group">
                                              <br />
                                              <input type="checkbox" id="IsCorrectionInputFile">&nbsp;
                                              <label>EPT Corr.Input File </label>
                                            </div>
                                          </div>
                                          <div class="col-sm-3">
                                            <div class="form-group">
                                              <br />
                                              <input type="checkbox" id="IsCorrectionInputInstructions">&nbsp;
                                              <label>EPT Corr.Instructions </label>
                                            </div>
                                          </div>
                                        </div>
                                        <!--From Mail Details Column Panel-->
                                        <div class="row">

                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Submit CC</label>
                                              <input class="form-control" type="text" id="txtSubmitCC">
                                            </div>
                                          </div>
                                        </div>

                                        <!--Copyrights Details Column Panel-->
                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Copyrights</label>
                                              <textarea id="txtCopyrights" class="form-control rounded-0" autocomplete="off" data-origin="textarea"></textarea>
                                            </div>
                                          </div>
                                          <div class="col-md-12" style="display:none">
                                            <div class="form-group">
                                              <label>To Copyrights</label>
                                              <textarea id="txtToCopyrights" class="form-control rounded-0" autocomplete="off" data-origin="textarea"></textarea>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <label>Instruction</label>
                                            <input class="form-control" type="text" id="txttoInstructions">
                                          </div>
                                        </div>
                                      </form>
                                    </div>

                                    <div class="tab-pane" id="divMailDetails">
                                      <div class="col-12">
                                        <div class="form-group">
                                          <div class="form-group col-12" id="Divmail">
                                            <label for="Txt_MailBody">Mail Body<em>*</em></label>
                                            <textarea id="Txt_MailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="tab-pane" id="divConfirmationMailDetails">

                                      <div class="col-12">
                                        <div class="form-group">
                                          <div class="form-group col-12" id="DivmailConfirmation">
                                            <label for="Txt_ConfirmationMailBody">Confirmation MailBody<em>*</em></label>
                                            <textarea id="Txt_ConfirmationMailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
                                          </div>
                                        </div>
                                      </div>
                                    </div>


                                    <div class="tab-pane" id="divPreviewDetails">
                                      <div class="row">
                                        <div class="col-sm-12 row">
                                          <div class="col-sm-2 divArticlePreview">
                                            <label>ArticleNo</label>
                                            <input class="form-control" type="text" id="TxtArticleNo">
                                          </div>

                                          <div class="col-sm-1 divIssuePreview">
                                            <label>Volume</label>
                                            <input class="form-control" type="text" id="TxtVolume" max="4">
                                          </div>
                                          <div class="col-sm-1 divIssuePreview">
                                            <label>Issue</label>
                                            <input class="form-control" type="text" id="TxtIssue" max="4">
                                          </div>

                                          <div class="col-sm-2">
                                            <br />
                                            <button type="button" class="btn btn-outline-info" (click)="PreviewConfigData();">Get</button>
                                          </div>
                                        </div>
                                      </div>
                                      <div id="divPreviewMain" style="overflow: hidden; overflow-y: auto;">
                                        <div id="divPreviewData"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-2" id="DynamicTagList" style="display: none; ">
                                  <div class="col-sm-12" id="divDynamicTagList" style="overflow: hidden; overflow-y: auto;">
                                    <div class="col" *ngFor="let item of DynamicTagList">
                                      <table width="100%">
                                        <tr style="height:5vh;">
                                          <td>
                                            <h6 class="mb-1">{{item.DynamicTag}}</h6>
                                            <div>
                                              <span class="small-box-footer spFilter " style="font-size: 10px;color:blue">{{item.TagDescription}}</span>
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                      <hr />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="modal-footer">
                            <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                            <button type="button" id="configsave" class="btn btn-outline-success waves-effect waves-light divMainConfig" (click)="AddConfig()">Save</button>
                          </div>
                        </div>
                      </div>
                      <div id="LoadingImagePopup">
                        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
                      </div>
                    </div>
                    <!--popup end config data-->
                  </div>
                  <!--Remainder tab-->
                  <div id="ReminderTab" class="tab-pane">
                    <!--<form #form="ngForm" id="Reminder">-->
                    <span id="spAddReminder" class="proofingAddbtn" (click)="ShowReminder()" style="display:none"></span>
                    <span id="spUpdateReminder" class="proofingAddbtn" (click)="UpdateReminderData()" style="display:none"></span>
                    <div class="col-md-12">
                      <div class="form-group tblRightsList fixTableHead">
                        <table id="tblAddReminderList" class="table" style="width: 100%">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Interval Type</th>
                              <th>Stage</th>
                              <th>Sequence </th>
                              <th>Subject</th>
                              <th style="display:none">Interval Day </th>
                              <th style="display:none">StageName</th>
                              <th style="display:none">CC</th>
                              <th style="display:none">Submit CC</th>
                              <th style="display:none">BCC Email</th>
                              <th style="display:none">MailBody</th>
                              <th style="display:none">Signature</th>
                              <th style="text-align:center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="modal" id="myModalReminder" [style.display]="showModal ? 'block' : 'none'">
                      <div class="modal-dialog modal-xl custome-modal">
                        <div class="modal-content" id="divReminderPopup">
                          <!-- Modal Header -->

                          <div class="modal-header">
                            <h4 class="modal-title">Proofing Reminder Details</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="Reminderhide()" id="btnReminderHide">&times;</button>
                          </div>
                          <div class="modal-body" id="proofremind" style="overflow:hidden;top:-15px">

                            <div class="divMainConfig">
                              <ul class="nav nav-tabs nav-tabs-custom" id="ULTabulPopup" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" data-toggle="tab" href="#divReminder" name="Proofing">Reminder</a>
                                </li>
                                <li class="nav-item"><a class="nav-link " data-toggle="tab" href="#divReminderMail">MailBody</a></li>
                                <!--<li class="nav-item" id="tabPreviewreminder">
                                  <a class="nav-link " data-toggle="tab" href="#divRemindPreviewtab">Preview</a>
                                </li>-->
                                <li class="nav-item tab_btn">
                                  <h6 (click)="addDynamicTagListReminder()">
                                    <i class="fa fa-tags"></i> Dynamic Tags
                                  </h6>
                                </li>
                              </ul>
                              <br />
                              <div class="row">
                                <div class="col">
                                  <div class="tab-content">
                                    <div class="tab-pane active" id="divReminder" style="overflow: hidden; overflow-y: auto;">
                                      <form #form="ngForm" id="formReminder">
                                        <div class="row">
                                          <div class="col-sm-3">
                                            <div class="form-group">
                                              <label>Stage</label>
                                              <select class="form-control" id="ddlRStageList">
                                                <option value="0" selected="selected">Select</option>
                                                <option *ngFor="let item of stageList" value={{item.ID}}>{{item.Stage}}</option>
                                              </select>
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div class="form-group">
                                              <label>Sequence</label>
                                              <input class="form-control" type='number' id="txtReminderCount" placeholder="" min="0">
                                            </div>
                                          </div>

                                          <div class="col-md-3">
                                            <div class="form-group">
                                              <label>Interval</label>
                                              <input class="form-control" type='number' id="txtIntervalDay" placeholder="" min="0">
                                            </div>
                                          </div>

                                          <div class="col-md-3">
                                            <div class="form-group">
                                              <label>Interval Type</label>
                                              <select class="form-control" type="number" id="ddlIntervalType">
                                                <option value="Days">Days</option>
                                                <option value="Hours">Hours</option>
                                              </select>
                                            </div>
                                          </div>

                                        </div>

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Subject</label>
                                              <input class="form-control" type="text" id="txtRSubject">
                                            </div>
                                          </div>
                                          <div class="col-md-6" style="display:none">
                                            <div class="form-group">
                                              <label>Stage Name</label>
                                              <input class="form-control" type="text" id="txtRStageName">
                                            </div>
                                          </div>
                                        </div>

                                        <div class="row">
                                          <div class="col-md-6">
                                            <div class="form-group">
                                              <label>From Email</label>
                                              <input class="form-control" type="text" id="txtRFromEmailId" (change)="emailidOnly($event)" />
                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="form-group">
                                              <label>To Email</label>
                                              <input class="form-control" type="text" id="txtRToEmailId" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>CC</label>
                                              <input class="form-control" type="text" id="txtRCC" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>BCC Email</label>
                                              <input class="form-control" type="text" id="txtRSubmitCC" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Signature</label><em style="color:red">*</em>
                                              <textarea id="txtRemindSignature" class="form-control"></textarea>
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <label>Submit CC</label>
                                              <input class="form-control" type="text" id="txtRBCCEmail" (change)="EmailValidation($event)" />
                                            </div>
                                          </div>
                                          <!--for id value-->
                                          <div class="col-md-4" style="display:none">
                                            <div class="form-group">
                                              <label>Submit CC</label>
                                              <input class="form-control" type="text" id="txtRid">
                                            </div>
                                          </div>
                                          <!--for ProofingSystemId value-->
                                          <div class="col-md-4" style="display:none">
                                            <div class="form-group">
                                              <label>Submit CC</label>
                                              <input class="form-control" type="text" id="txtRProofingSystemId" placeholder="">
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>

                                    <div class="tab-pane" id="divReminderMail">

                                      <div class="col-12">
                                        <div class="form-group">
                                          <div class="form-group col-12" id="DivReminderMailData">
                                            <label for="Txt_ProofRemindMailBody">Mail Body<em>*</em></label>
                                            <textarea id="Txt_ProofRemindMailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
                                          </div>
                                        </div>
                                      </div>

                                    </div>

                                    <div class="tab-pane" id="divRemindPreviewtab" style="display:none">
                                      <div class="row">
                                        <div class="col-sm-12 row">
                                          <div class="col-sm-2 divArticlePreview">
                                            <label>ArticleNo</label>
                                            <input class="form-control" type="text" id="TxtArticleNoRem" placeholder="">
                                          </div>

                                          <div class="col-sm-1 divIssuePreview">
                                            <label>Volume</label>
                                            <input class="form-control" type="text" id="TxtVolumeRem" max="4" placeholder="">
                                          </div>
                                          <div class="col-sm-1 divIssuePreview">
                                            <label>Issue</label>
                                            <input class="form-control" type="text" id="TxtIssueRem" max="4" placeholder="">
                                          </div>

                                          <div class="col-sm-2">
                                            <br />
                                            <button type="button" class="btn btn-outline-info" (click)="PreviewConfigData();">Get</button>
                                          </div>
                                        </div>
                                      </div>
                                      <div id="divPreviewMain" style="overflow: hidden; overflow-y: auto;">
                                        <div id="divPreviewData"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-2" id="DynamicTagListReminder" style="display: none; ">
                                  <div class="col-sm-12" id="divDynamicTagListRem" style="overflow: hidden; overflow-y: auto;">
                                    <div class="col" *ngFor="let item of DynamicTagList">
                                      <table width="100%">
                                        <tr style="height:5vh;">
                                          <td>
                                            <h6 class="mb-1">{{item.DynamicTag}}</h6>
                                            <div>
                                              <span class="small-box-footer spFilter " style="font-size: 10px;color:blue">{{item.TagDescription}}</span>
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                      <hr />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="Reminderhide()">Close</button>
                            <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="AddReminder()">Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="LoadingImagePopup">
                      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
                    </div>
                  </div>
                </div>
                <!--</div>-->
              </div>
              <!-- Footer -->
              <div class="col" style="text-align:right">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" (click)="BacktoConfigList()">Close</button>&nbsp;&nbsp;&nbsp;
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateConfigDetails()">{{popUpButtonText}}</button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

